import { type FC } from 'react';

import { type PartnerTaskDto } from '@/common/types/query/tasks';
import { useAppSelector } from '@/redux/store';

import {
  DiscordSocial,
  InstagramSocial,
  TelegramSocial,
  TiktokSocial,
  XSocial,
  YoutubeSocial,
} from './Socials';

type SocialComponentProps = {
  link?: string;
};

const SocialList: FC = () => {
  const tasks = useAppSelector(
    (state) =>
      state.tasks.social?.flatMap((partner) => partner.partnerTask) || [],
  );
  const socialComponentsMap: { [key: string]: FC<SocialComponentProps> } = {
    telegram: TelegramSocial,
    x: XSocial,
    discord: DiscordSocial,
    youtube: YoutubeSocial,
    instagram: InstagramSocial,
    tiktok: TiktokSocial,
  };

  const getSocialKey = (task: PartnerTaskDto): string | null => {
    const link = task.link.toLowerCase();

    if (
      (link.includes('t.me') || link.includes('telegram')) &&
      !link.includes('chat')
    )
      return 'telegram';

    if (link.includes('x.com') || link.includes('twitter')) return 'x';

    if (link.includes('discord')) return 'discord';

    if (link.includes('youtube')) return 'youtube';

    if (link.includes('instagram')) return 'instagram';

    if (link.includes('tiktok')) return 'tiktok';

    return null;
  };

  return (
    <div className="w-full flex items-center justify-center gap-4">
      {tasks.map((task) => {
        const key = getSocialKey(task);

        if (key) {
          const SocialComponent = socialComponentsMap[key];

          return <SocialComponent key={task.id} link={task.link} />;
        }

        return null;
      })}
    </div>
  );
};

export { SocialList };
